module.exports = __webpack_public_path__ + "img/face49.f918b832.gif";